exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status{width:100%;height:120px;padding:15px;color:#fff;margin-right:20px;margin-bottom:10px;border-radius:2px}.status:last-child{margin-right:0}.status h6{display:block;width:100%;font-size:1.6em;margin-top:5px;border-radius:5px;text-align:right}.status i{font-size:3em}.status-content{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-right:20px;text-align:center;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4445755c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CardStatus.vue
// module id = 861
// module chunks = 0